"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBuyOnlineStatus = void 0;
var types_1 = require("../../types");
var buy_online_status_1 = require("../models/buy-online-status");
var get_buy_online_status_1 = require("../utils/get-buy-online-status");
// порядок проверок в этой функции важен
function getBuyOnlineStatus(params) {
    var tourResourcesParams = {
        tour: params.tour,
        resources: params.resources,
        resourcesData: params.resourcesData
    };
    if (!params.detailActualizationCompleted) {
        return buy_online_status_1.BuyOnlineStatus.detailActualizationNotCompleted;
    }
    // https://agile.sletat.ru/jiraurl/browse/SLT-1063
    if ((0, get_buy_online_status_1.isTourSold)(params.tour) || params.isActualizationNotAvailable) {
        return buy_online_status_1.BuyOnlineStatus.tourSold;
    }
    if (params.originalCurrency !== types_1.CurrencyId.RUB) {
        return buy_online_status_1.BuyOnlineStatus.incorrectCurrency;
    }
    if (!(0, get_buy_online_status_1.isMoreThanOneDayBeforeDeparture)(tourResourcesParams)) {
        return buy_online_status_1.BuyOnlineStatus.lessThanOneDayBeforeDeparture;
    }
    var includedInAvailableTOs = params.operatorsWithBilling.includes(params.sourceId);
    if (!includedInAvailableTOs) {
        return buy_online_status_1.BuyOnlineStatus.operatorDoesntSupportOnlinePayment;
    }
    return buy_online_status_1.BuyOnlineStatus.available;
}
exports.getBuyOnlineStatus = getBuyOnlineStatus;
